export enum TranslationsNamespaces {
  LOGIN = 'login',
  PROFILE = 'profile',
}
